/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPrescriptions } from 'app/entities/prescription/prescription.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { getEntities as getTreatmentPlans } from 'app/entities/treatment-plan/treatment-plan.reducer';
import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './lab-prescription.reducer';

export const LabPrescriptionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const prescriptions = useAppSelector(state => state.prescription.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const appointments = useAppSelector(state => state.appointments.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const treatmentPlans = useAppSelector(state => state.treatmentPlan.entities);
  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const labPrescriptionEntity = useAppSelector(state => state.labPrescription.entity);
  const loading = useAppSelector(state => state.labPrescription.loading);
  const updating = useAppSelector(state => state.labPrescription.updating);
  const updateSuccess = useAppSelector(state => state.labPrescription.updateSuccess);
  const patientTypeValues = Object.keys(PatientType);
  const orderStatusValues = Object.keys(OrderStatus);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/lab-prescription${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPrescriptions({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDiagLabs({}));
    dispatch(getDoctors({}));
    dispatch(getAppointments({}));
    dispatch(getDiaglabAssistants({}));
    dispatch(getTreatmentPlans({}));
    dispatch(getPatientProcedures({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...labPrescriptionEntity,
      ...values,
      prescription: prescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      servedBy: diagLabs.find(it => it.id.toString() === values.servedBy?.toString()),
      orderedBy: doctors.find(it => it.id.toString() === values.orderedBy?.toString()),
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      otcBy: diaglabAssistants.find(it => it.id.toString() === values.otcBy?.toString()),
      treatmentPlan: treatmentPlans.find(it => it.id.toString() === values.treatmentPlan?.toString()),
      procedure: patientProcedures.find(it => it.id.toString() === values.procedure?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          patientType: 'OP',
          orderStatus: 'CREATED',
          addedByType: 'DOCTOR',
          modifiedByType: 'DOCTOR',
          ...labPrescriptionEntity,
          prescription: labPrescriptionEntity?.prescription?.id,
          glucoUser: labPrescriptionEntity?.glucoUser?.id,
          servedBy: labPrescriptionEntity?.servedBy?.id,
          orderedBy: labPrescriptionEntity?.orderedBy?.id,
          appointment: labPrescriptionEntity?.appointment?.id,
          otcBy: labPrescriptionEntity?.otcBy?.id,
          treatmentPlan: labPrescriptionEntity?.treatmentPlan?.id,
          procedure: labPrescriptionEntity?.procedure?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labPrescription.home.createOrEditLabel" data-cy="LabPrescriptionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labPrescription.home.createOrEditLabel">Create or edit a LabPrescription</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-prescription-id"
                  label={translate('tinyMedicRestApp.labPrescription.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.status')}
                id="lab-prescription-status"
                name="status"
                data-cy="status"
                type="text"
                validate={{
                  maxLength: { value: 150, message: translate('entity.validation.maxlength', { max: 150 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.timestampentry')}
                id="lab-prescription-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.active')}
                id="lab-prescription-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.lastupdated')}
                id="lab-prescription-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.cursor')}
                id="lab-prescription-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.microSec')}
                id="lab-prescription-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.patientType')}
                id="lab-prescription-patientType"
                name="patientType"
                data-cy="patientType"
                type="select"
              >
                {patientTypeValues.map(patientType => (
                  <option value={patientType} key={patientType}>
                    {translate(`tinyMedicRestApp.PatientType.${patientType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.exposed')}
                id="lab-prescription-exposed"
                name="exposed"
                data-cy="exposed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.otc')}
                id="lab-prescription-otc"
                name="otc"
                data-cy="otc"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.orderStatus')}
                id="lab-prescription-orderStatus"
                name="orderStatus"
                data-cy="orderStatus"
                type="select"
              >
                {orderStatusValues.map(orderStatus => (
                  <option value={orderStatus} key={orderStatus}>
                    {translate(`tinyMedicRestApp.OrderStatus.${orderStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.addedByType')}
                id="lab-prescription-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.addedByID')}
                id="lab-prescription-addedByID"
                name="addedByID"
                data-cy="addedByID"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.modifiedByType')}
                id="lab-prescription-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.labPrescription.modifiedByID')}
                id="lab-prescription-modifiedByID"
                name="modifiedByID"
                data-cy="modifiedByID"
                type="text"
              />
              <ValidatedField
                id="lab-prescription-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.labPrescription.prescription')}
                type="select"
                required
              >
                <option value="" key="0" />
                {prescriptions
                  ? prescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="lab-prescription-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.labPrescription.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="lab-prescription-servedBy"
                name="servedBy"
                data-cy="servedBy"
                label={translate('tinyMedicRestApp.labPrescription.servedBy')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-prescription-orderedBy"
                name="orderedBy"
                data-cy="orderedBy"
                label={translate('tinyMedicRestApp.labPrescription.orderedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-prescription-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.labPrescription.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-prescription-otcBy"
                name="otcBy"
                data-cy="otcBy"
                label={translate('tinyMedicRestApp.labPrescription.otcBy')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-prescription-treatmentPlan"
                name="treatmentPlan"
                data-cy="treatmentPlan"
                label={translate('tinyMedicRestApp.labPrescription.treatmentPlan')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentPlans
                  ? treatmentPlans.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-prescription-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.labPrescription.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-prescription" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabPrescriptionUpdate;
